<template>
  <div v-loading="loading" class="radish-list" style="position:relative;">
    <el-tabs v-if="!hideTab" v-model="activeTab" type="card" @tab-click="handleTabClick">
      <el-tab-pane v-for="(n, k) in num" :key="k" :label="k + '(' + n + ')'" :name="k"></el-tab-pane>
      <el-tab-pane
        v-if="pro.finalRadishIds"
        :label="'最终人选(' + pro.finalRadishIds.length + ')'"
        name="最终人选"
      ></el-tab-pane>
      <el-tab-pane label="反馈汇总" name="反馈汇总"></el-tab-pane>
      <el-tab-pane label="圆手人选" name="圆手人选">
        <span slot="label">
          <span>圆手人选</span> <span v-if="lvBadge" class="lv-badge">{{ lvBadge }}</span>
        </span>
      </el-tab-pane>
    </el-tabs>
    <div v-if="activeTab == '最终人选'">
      <radishList
        v-if="pro.finalRadishIds && pro.finalRadishIds.length > 0"
        ref="radishList"
        :show-search="false"
        :ids="pro.finalRadishIds"
      ></radishList>
      <div v-else>暂无数据</div>
    </div>
    <div v-if="activeTab == '圆手人选'">
      <div class="radish-act-grp" v-if="hasPermisson()" style="margin:5px">
        <span>批量操作：</span>
        <div class="radish-btn radish-btn-primary" @click="showLvRecommend(true)">推荐</div>
      </div>
      <lvRadishList
        ref="lvRadishList"
        :data="lvTable"
        :project="pro"
        :height="tableHeight"
        :on-click-setting="showLvAction"
        @computedLvBadge="computedLvBadge"
      ></lvRadishList>
    </div>
    <div v-else-if="activeTab === '反馈汇总'"><FeedBackSummary ref="FeedBackSummary" :pid="pid"></FeedBackSummary></div>
    <template v-else>
      <div v-if="isSearchShow" class="radish-search">
        <div class="simple">
          <formItem
            v-for="(f, fk) in searchOrder"
            :key="fk + 's'"
            :type="addFields.includes(f) ? addFieldOptions[f].type : searchFieldsPro[f] && searchFieldsPro[f].type"
            :is-inline="true"
            :width="
              addFields.includes(f)
                ? addFieldOptions[f].width || '200px'
                : searchFieldsPro[f] && searchFieldsPro[f].width
            "
            :label="(searchFieldsPro[f] && searchFieldsPro[f].label) || f"
            :options="
              addFields.includes(f)
                ? addFieldOptions[f].options || []
                : searchFieldsPro[f] && searchFieldsPro[f].options
            "
            :content="
              addFields.includes(f) ? searchData[f] : searchData[searchFieldsPro[f] && searchFieldsPro[f].label]
            "
            :label-width="
              addFields.includes(f)
                ? addFieldOptions[f].labelWidth
                : searchFieldsPro[f] && searchFieldsPro[f].labelWidth
            "
            :handle-data-change="handleSearchChange"
          ></formItem>
          <div>
            <el-button type="primary" size="mini" round @click="handleSearch">搜索</el-button>
            <el-button size="mini" round @click="cleanSearch">清空</el-button>
            <el-button size="mini" round @click="orderCondition">搜索项顺序</el-button>
          </div>
        </div>
      </div>
      <div v-if="!loading" ref="radishTableWapper" @copy="onCopy">
        <a-table
          v-if="listMode === 'table'"
          ref="radishTable"
          :data="radishes"
          :heads="tableHeads"
          :height="tableHeight"
          :active-row-id="activeRowId"
          :storage-name="storageName"
          :start="limit * (page - 1)"
          :on-set-hidden-cell="setHiddenCell"
          :on-set-cell-order="setCellOrder"
        >
          <template slot="actions">
            <div class="radish-btn radish-btn-primary" @click="showSearch">
              {{ isSearchShow ? '收起' : '展开' }}搜索
            </div>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <span>展现形式：</span>
              <el-radio-group v-model="listMode" size="mini">
                <el-radio-button label="table">列表模式</el-radio-button>
                <el-radio-button label="list">详情模式</el-radio-button>
              </el-radio-group>
            </div>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <span>批量操作：</span>
              <div class="radish-btn radish-btn-primary" @click="showIntoProject(true)">加入其他项目</div>
              <div class="radish-btn radish-btn-primary" @click="generateProjectSearchProject">推荐人选汇总</div>
              <div
                v-if="showExportProjectReport"
                class="radish-btn radish-btn-primary"
                @click="onExportProjectReport()"
              >
                生成项目报告
              </div>
              <template v-if="hasPermisson()">
                <div class="radish-btn radish-btn-primary" @click="showRecommend(true)">推荐</div>
                <div class="radish-btn radish-btn-primary" @click="outProject(true)">移出项目</div>
                <div class="radish-btn radish-btn-primary" @click="showEditDialog">修改字段内容</div>
                <div class="radish-btn radish-btn-primary" @click="showCateDialog('添加')">添加职能模块</div>
                <!-- <div class="radish-btn radish-btn-primary" @click="showCateDialog('删除')">删除职能模块</div> -->
                <div class="radish-btn radish-btn-primary" @click="addToFavorite">加入收藏夹</div>
                <div v-if="isAdmin" class="radish-btn radish-btn-primary" @click="testMatch">匹配测试</div>
              </template>
              <div class="radish-btn radish-btn-primary" @click="allotBelonger">人选跟进责任分配</div>
            </div>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <span>排序：</span>
              <el-radio-group v-model="sortBy" class="radish-act-radio" size="mini" @change="changeSort">
                <el-radio-button label="匹配度"></el-radio-button>
                <el-radio-button label="相关度"></el-radio-button>
                <el-radio-button label="公司"></el-radio-button>
                <el-radio-button label="createdAt">时间</el-radio-button>
                <el-radio-button label="意向"></el-radio-button>
              </el-radio-group>
            </div>
            &nbsp;&nbsp;
            <!-- <div class="radish-act-grp">
              <span>颜色：</span>
              <el-switch v-model="yxColorOn" @change="changeColor"> </el-switch>
            </div>
            &nbsp;&nbsp; -->
            <div class="radish-act-grp">
              <el-radio-group v-model="ccSearch" size="mini">
                <el-radio-button label="all">所有</el-radio-button>
                <el-radio-button label="nocc">不看cc</el-radio-button>
                <el-radio-button label="cc">只看cc</el-radio-button>
              </el-radio-group>
            </div>
            <!-- <div class="radish-btn" @click="outAll" round>移出全部未推荐人选</div> -->
          </template>
        </a-table>
        <!-- <a-list
          v-else-if="listMode === 'list'"
          ref="radishTable"
          type="radish-pro"
          :data="radishes"
          :height="tableHeight"
          :start="limit * (page - 1)"
          :on-click-name="clickName"
          :on-click-company="clickCompany"
          :on-click-setting="showAction"
          :on-click-document="showFiles"
          :on-interview="showInterview"
          :on-eliminate="showEliminate"
          :on-click-status="clickStatus"
        > -->
        <a-list
          v-else-if="listMode === 'list'"
          ref="radishTable"
          type="radish-pro"
          :data="radishes"
          :height="tableHeight"
          :start="limit * (page - 1)"
          :on-click-name="clickName"
          :on-click-company="clickCompany"
          :on-click-setting="showAction"
          :on-click-document="showFiles"
          :on-click-status="clickStatus"
        >
          <template slot="actions">
            <div class="radish-btn radish-btn-primary" @click="showSearch">
              {{ isSearchShow ? '收起' : '展开' }}搜索
            </div>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <span>展现形式：</span>
              <el-radio-group v-model="listMode" size="mini">
                <el-radio-button label="table">列表模式</el-radio-button>
                <el-radio-button label="list">详情模式</el-radio-button>
              </el-radio-group>
            </div>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <span>批量操作：</span>
              <div class="radish-btn radish-btn-primary" @click="showIntoProject(true)">加入其他项目</div>
              <template v-if="hasPermisson()">
                <div class="radish-btn radish-btn-primary" @click="showRecommend(true)">推荐</div>
                <div class="radish-btn radish-btn-primary" @click="outProject(true)">移出项目</div>
                <div class="radish-btn radish-btn-primary" @click="showEditDialog">修改字段内容</div>
                <div class="radish-btn radish-btn-primary" @click="showCateDialog('添加')">添加职能模块</div>
                <!-- <div class="radish-btn radish-btn-primary" @click="showCateDialog('删除')">删除职能模块</div> -->
                <div class="radish-btn radish-btn-primary" @click="addToFavorite">加入收藏夹</div>
                <div v-if="isAdmin" class="radish-btn radish-btn-primary" @click="testMatch">匹配测试</div>
              </template>
            </div>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <span>排序：</span>
              <el-radio-group v-model="sortBy" class="radish-act-radio" size="mini" @change="changeSort">
                <el-radio-button label="匹配度"></el-radio-button>
                <el-radio-button label="相关度"></el-radio-button>
                <el-radio-button label="公司"></el-radio-button>
                <el-radio-button label="createdAt">时间</el-radio-button>
                <el-radio-button label="意向"></el-radio-button>
              </el-radio-group>
            </div>
            &nbsp;&nbsp;
            <div class="radish-act-grp">
              <el-radio-group v-model="ccSearch" size="mini">
                <el-radio-button label="all">所有</el-radio-button>
                <el-radio-button label="nocc">不看cc</el-radio-button>
                <el-radio-button label="cc">只看cc</el-radio-button>
              </el-radio-group>
            </div>
            <!-- <div class="radish-btn" @click="outAll" round>移出全部未推荐人选</div> -->
          </template>
        </a-list>
      </div>
      <div class="radish-page">
        <el-pagination
          :current-page="page"
          :page-sizes="pageSizes"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </template>
    <div
      v-if="!hasPermisson()"
      title="仅参与项目人员可以操作"
      style="position:absolute;top:45px;left:0;right:10px;bottom:55px;cursor:not-allowed;"
    ></div>
    <interviewDialog ref="interviewDialog" :on-confirm="loadData"></interviewDialog>
    <interviewListDialog ref="interviewListDialog"></interviewListDialog>
    <feedbackDialog ref="feedbackDialog"></feedbackDialog>
    <clientfeedbackDialog ref="clientfeedbackDialog"></clientfeedbackDialog>
    <offerDialog ref="offerDialog" :on-confirm="loadData"></offerDialog>
    <toworkDialog ref="toworkDialog" :on-confirm="loadData"></toworkDialog>
    <eliminateDialog ref="eliminateDialog" :on-confirm="loadData"></eliminateDialog>
    <Popper :visible.sync="popperVisible" :target-id="popperTarget">
      <div class="radish-pop">
        <!-- <FileTable
          v-if="popperContent == 'files'"
          :files="files"
          :rid="popperTarget && popperTarget.replace('附件', '')"
          :project-id="pid"
          :paginate="false"
          :on-delete="deleteAttachment"
          width="600"
          height="300"
        /> -->
        <AttachmentsType
          v-if="popperContent == 'files'"
          :attach="files"
          :rid="popperTarget && popperTarget.replace('附件', '')"
          :paginate="false"
          :on-delete="deleteAttachment"
          :width="600"
          :height="300"
        />
        <!-- 操作 -->
        <div v-if="popperContent == 'lvAction'" class="dropdown-popper">
          <div class="item" @click="showRecommend(false)">推荐到其他项目</div>
          <div
            v-if="currentRow.人选进展阶段 == 'Call' || currentRow.人选进展阶段[0] == 'Call'"
            class="item"
            @click="showDia('RecommendCreate')"
          >
            推荐给客户
          </div>
        </div>
        <div v-if="popperContent == 'action'" class="dropdown-popper">
          <div class="item" @click="setTop">{{ currentRow['置顶'] ? '取消置顶' : '置顶' }}</div>
          <!-- <div class="item" @click="highProbability">{{}}高概率offer</div> -->
          <div class="item" @click="uploadCv">上传简历</div>
          <div class="item" @click="uploadReport">上传推荐报告</div>
          <div class="item" @click="updateHighProbability">
            {{ currentRow['高概率'] ? '取消' : '设置为' }}高概率offer人选
          </div>
          <div class="item" @click="showRadishPortrait">岗位匹配度</div>
          <div class="item" @click="showRecommend(false)">推荐到其他项目</div>
          <div class="item" @click="addBelonger">加入我的待沟通</div>
          <div
            v-if="currentRow.人选进展阶段 == 'Call' || currentRow.人选进展阶段[0] == 'Call'"
            class="item"
            @click="outProject(false)"
          >
            移出项目
          </div>
          <div
            v-if="currentRow.人选进展阶段 == 'Call' || currentRow.人选进展阶段[0] == 'Call'"
            class="item"
            @click="openQuickChat"
          >
            快速沟通
          </div>
          <div
            v-if="currentRow.人选进展阶段 == 'Call' || currentRow.人选进展阶段[0] == 'Call'"
            class="item"
            @click="showDia('RecommendCreate')"
          >
            推荐给客户
          </div>
          <div
            v-if="currentRow.人选进展阶段 == '推荐' || currentRow.人选进展阶段[0] == '推荐'"
            class="item"
            @click="cancelRecommend"
          >
            取消推荐
          </div>
          <div
            v-if="currentRow.人选进展阶段 == '推荐' || currentRow.人选进展阶段[0] == '推荐'"
            class="item"
            @click="genRepo"
          >
            生成推荐报告
          </div>
          <div
            v-if="currentRow.人选进展阶段 == '推荐' || currentRow.人选进展阶段[0] == '推荐'"
            class="item"
            @click="showDia('RecommendFeedback')"
          >
            推荐反馈
          </div>
          <div
            v-if="currentRow.人选进展阶段[0] == '面试' || currentRow.人选进展阶段 == '终面'"
            class="item"
            @click="showDia('InterviewFeedback')"
          >
            面试反馈
          </div>
          <div v-if="currentRow.人选进展阶段 == 'offer谈判'" class="item" @click="showDia('OfferFeedback')">
            offer反馈
          </div>
          <div
            v-if="
              currentRow.人选进展阶段 == '推荐' ||
                currentRow.人选进展阶段[0] == '推荐' ||
                currentRow.人选进展阶段 == '终面' ||
                currentRow.人选进展阶段 == 'offer谈判'
            "
            class="item"
            @click="showDia('InterviewCreate')"
          >
            安排客户面试
          </div>
          <div v-if="currentRow.人选进展阶段[0] == '面试'" class="item" @click="showDia('InterviewCreate')">
            安排下一轮面试
          </div>
          <div
            v-if="currentRow.人选进展阶段[0] == '面试' || currentRow.人选进展阶段 == '终面'"
            class="item"
            @click="showDia('OfferMaybe')"
          >
            拟offer
          </div>
          <div v-if="currentRow.人选进展阶段 == 'offer谈判'" class="item" @click="showYejifenchengDia()">确认offer</div>
          <!-- <div v-if="currentRow.人选进展阶段 == 'offer谈判'" class="item" @click="showDia('OfferConfirm')">
            确认offer
          </div> -->
          <div v-if="currentRow.人选进展阶段 == 'offer谈判'" class="item" @click="offerFeedbackGiveup">人选放弃</div>
          <div v-if="currentRow.人选进展阶段 == '离职辅导'" class="item" @click="showDia('LeaveGuide')">离职辅导</div>
          <div v-if="currentRow.人选进展阶段 == '离职辅导'" class="item" @click="showDia('OfferEdit')">修改offer</div>
          <div v-if="currentRow.人选进展阶段 == '离职辅导'" class="item" @click="showDia('ToworkConfirm')">
            确认到岗
          </div>
          <div v-if="currentRow.人选进展阶段 == '离职辅导'" class="item" @click="showDia('ToworkNot')">未入职</div>
          <div v-if="currentRow.人选进展阶段 == '到岗'" class="item" @click="showDia('WarrantyConfirm')">确认过保</div>
          <div v-if="currentRow.人选进展阶段 == '到岗'" class="item" @click="showDia('WarrantyNot')">未过保</div>
        </div>
      </div>
    </Popper>
    <editDialog ref="editDialog" :on-confirm="loadData"></editDialog>
    <cateDialog ref="cateDialog" :on-confirm="loadData"></cateDialog>
    <UploadDialog ref="UploadDialog" :type="uploadType" :label="attachType" :on-success="uploadSuccess"></UploadDialog>
    <proScore ref="proScore"></proScore>
    <RadishProgress ref="RadishProgress" :on-confirm="loadOne"></RadishProgress>
    <QuickChat ref="QuickChat" :on-confirm="loadOne"></QuickChat>
    <ProgressDia ref="ProgressDia" :on-confirm="loadOne"></ProgressDia>
    <projectReportDialog ref="projectReportDialog"></projectReportDialog>
    <ProjectExportOptions
      ref="projectExportOptions"
      @exportProjectMappingReport="onExportProjectMappingReport"
    ></ProjectExportOptions>
    <AllotBelonger ref="AllotBelonger" :project="pro" @confirm="allotBelongerConfirm"></AllotBelonger>
    <ProjectReportEditor
      ref="ProjectReportEditor"
      :type="'projectSearchReport'"
      @confirm="confirm"
    ></ProjectReportEditor>
    <YejifenchengDia ref="YejifenchengDia" @onConfirm="yejiConfirm"></YejifenchengDia>
  </div>
</template>
<script>
import { FileTable } from '../../file'
import { Popper } from '../../project'
import interviewDialog from './dialog/interview-dialog'
import interviewListDialog from './dialog/interviewlist-dialog'
import feedbackDialog from './dialog/feedback-dialog'
import clientfeedbackDialog from './dialog/clientfeedback-dialog'
import eliminateDialog from './dialog/eliminate-dialog'
import editDialog from './dialog/edit-dialog'
import cateDialog from './dialog/cate-dialog'
import { searchFieldsPro } from './constant/fields-list'
import tableHeads from './constant/table-heads-pro'
import { arrRemove, download, hasPermisson } from '../../project/src/constant/utils'
import pickerOptions from './constant/picker-options'
import proScore from './components/radish-pro-score'
import aList from './table/a-list'
import RadishProgress from './progress/radish-progress'
import QuickChat from './progress/quick-chat'
import ProgressDia from './progress/progress-dia'
import YejifenchengDia from './progress/yejifencheng-dialog.vue'
import FeedBackSummary from '../../project/src/components/FeebBackSummary'
import projectReportDialog from './dialog/project-report-dialog'
import ProjectExportOptions from '../../project/src/dialog/ProjectExportOptions'
import AttachmentsType from './components/attachments-type'
import AllotBelonger from './dialog/allot-belonger'
import lvRadishList from '../../project/src/components/ProjectDetail20/LvDialog/lv-radish-list'

import ProjectReportEditor from '../../project/src/components/CreateProject20/ProjectReportEditor'
import { relatedCates, getDisplayLabels } from './constant/constant'

let searchOrderCopy = []

export default {
  components: {
    aList,
    interviewDialog,
    feedbackDialog,
    editDialog,
    cateDialog,
    interviewListDialog,
    clientfeedbackDialog,
    eliminateDialog,
    Popper,
    FileTable,
    proScore,
    RadishProgress,
    QuickChat,
    ProgressDia,
    FeedBackSummary,
    projectReportDialog,
    ProjectExportOptions,
    AttachmentsType,
    AllotBelonger,
    lvRadishList,
    ProjectReportEditor,
    YejifenchengDia,
  },
  mixins: [tableHeads],
  props: {
    pid: String,
    defaultTab: String,
    hideTab: { type: Boolean, default: false },
    showExportProjectReport: { type: Boolean, default: false },
  },
  data: function() {
    return {
      loading: false,
      activeTab: '所有人才',
      radishesCopy: [],
      radishesAll: [],
      radishes: [],
      total: 0,
      page: 1,
      pageSizes: [50, 100, 200],
      limit: 200,
      query: {},
      num: {
        所有人才: 0,
        待沟通: 0,
        职位推荐: 0,
        面试阶段: 0,
        offer谈判: 0,
        离职管理: 0,
        开票催款: 0,
      },
      searchFieldsPro: searchFieldsPro,
      searchOrder: [],
      searchData: {},
      yiOptions: ['Y', 'N', 'F'],
      tableHeight: 600,
      filesVisible: false,
      files: [],
      catData: [],
      actionVisible: false,
      currentRow: {},
      popperVisible: false,
      popperContent: '',
      popperTarget: '',
      isSearchShow: false,
      storageName: 'radishProHeads',
      attachType: '',
      uploadType: '',
      pro: {},
      sortBy: '公司',
      pickerOptions: pickerOptions,
      testMatchIds: [],
      yxColorOn: false,
      listMode: 'table',
      headers: [],
      ccSearch: 'all',
      defaultColors: [
        '#8497B0',
        '#D4B5ED',
        '#A7E8FF',
        '#8FAADC',
        '#C5E0B4',
        '#FFC000',
        '#FFB989',
        '#FF9F9F',
        '#44546A',
        '#A15FD7',
        '#00B0F0',
        '#70AD47',
        '#BF9000',
        '#FF6600',
        '#FF4747',
      ],
      lvTable: [],
      lvBadge: 0,
      addFieldOptions: {
        医疗科室: {
          label: '医疗科室',
          prop: '医疗科室',
          type: 'multSelect',
          width: '200px',
          options: [
            '外科',
            '神经外科',
            '脑科学',
            '骨科',
            'ICU',
            '血管外科',
            '心内科',
            '心外科',
            '呼吸科',
            '消化科',
            '内分泌科',
            '急诊科',
            '齿科',
            '眼科',
            '康复科',
            '肾内科',
            '耳鼻喉科',
            '生殖妇产',
            '设备科',
            '影像科',
            '超声科',
            '放射科',
            '信息科',
            '妇产科',
            '肿瘤科',
            '检验科',
            '血液科',
            'LDT三方检验所',
            '药企',
            '高校',
            '皮肤科',
          ],
        },
        业务方向: {
          label: '业务方向',
          prop: '业务方向',
          type: 'multSelect',
          width: '200px',
          options: ['化工', '精细化工', '医药', '石油&天然气', '冶金/矿业', '新能源'],
        },
        医疗背景: {
          label: '医疗背景',
          width: '200px',
          type: 'multSelect',
          options: ['内资', '外资'],
        },
        人才来源: {
          label: '人才来源',
          width: '200px',
          type: 'multSelect',
          options: [
            '公募公募',
            '公募专户',
            '券商自营',
            '券商资管',
            '保险和保险资管',
            '银行',
            '银行理财子',
            '私募',
            '第三方平台',
            '海外平台',
            '信托',
            '财富公司',
          ],
        },
        公开业绩: {
          label: '公开业绩',
          width: '200px',
          type: 'multSelect',
          options: ['有', '无'],
        },
        投资标的: {
          label: '投资标的',
          width: '200px',
          type: 'multSelect',
          options: ['公募FOF', '私募FOF'],
        },
        投资年限: {
          label: '投资年限',
          width: '200px',
          type: 'multSelect',
          options: ['1-3年', '3-7年', '7-10年', '10年以上'],
        },
        平台性质: {
          label: '平台性质',
          width: '200px',
          type: 'multSelect',
          options: ['美元/双币种', '人民币', '国家队', '险资', '券商直投', '战投/CVC'],
        },
        投资阶段: {
          label: '投资阶段',
          width: '200px',
          type: 'multSelect',
          options: ['天使轮及之前', 'PreA', 'A', 'B', 'C', 'Growth/PE', 'Pre-IPO', '一级半定增', 'Buyout'],
        },
        特殊能力: {
          label: '特殊能力',
          width: '200px',
          type: 'multSelect',
          options: ['募资资源', '投后管理', '有退出经验', 'sourcing项目'],
        },
        个人风格: {
          label: '个人风格',
          width: '200px',
          type: 'multSelect',
          options: [
            '保守',
            '稳健',
            '开拓（追求卓越）',
            '激进（狼性文化）',
            'social型',
            '学术研究型',
            '适合美元',
            '适合人民币',
            '具有创业精神',
            '情商高',
            '校友资源型',
            '政府资源型',
            '容貌风格',
            '远见型',
            '命令型',
            '民主型',
            '赞赏型',
            '变革型',
            '服务型',
          ],
        },
        '承揽-承做': {
          label: '承揽-承做',
          prop: '承揽-承做',
          type: 'multSelect',
          labelWidth: '100px',
          width: '220px',
          options: ['承揽', '承做', '存续期管理'],
        },
        '人员背景（股）': {
          label: '人员背景（股）',
          prop: '人员背景（股）',
          type: 'multSelect',
          labelWidth: '100px',
          width: '220px',
          options: ['四大背景', '监管背景', '政府背景', '产业背景', 'VIP', '在大平台做过', '在合资外资做过'],
        },
        转换诉求: {
          label: '转换诉求',
          width: '200px',
          type: 'multSelect',
          options: ['一级', '卖方', '买方-公募', '买方-保险', '买方-私募', '买方-券商资管', '上市公司董秘'],
        },
        港股背景: {
          label: '港股背景',
          width: '200px',
          type: 'multSelect',
          options: ['中资行', '外资行'],
        },
        意向平台: {
          label: '意向平台',
          width: '200px',
          type: 'multSelect',
          options: ['国企', '民企', '合资外资', '大平台', '中大型平台', '市场化激励平台'],
        },
        REITs任职情况: {
          label: 'REITs任职情况',
          width: '200px',
          labelWidth: '100px',
          type: 'multSelect',
          options: ['在任', '拟任', '未定'],
        },
        中后台背景: {
          label: '中后台背景',
          width: '220px',
          labelWidth: '100px',
          type: 'multSelect',
          options: [
            '四大背景',
            '券商背景',
            '公募背景',
            'PE股权',
            '监管背景',
            '外资',
            '海外',
            '咨询',
            'IT系统公司',
            '第三方验证机构',
            '评级机构',
            '海外评级机构',
            '托管',
            '律所',
            '前台业务背景',
            '审计',
            '银行',
            '会计师事务所',
          ],
        },
        HR背景: {
          label: 'HR背景',
          width: '200px',
          type: 'multSelect',
          options: [
            '金融-公募',
            '金融-券商',
            '金融-私募',
            '金融-PEVC',
            '金融-其他',
            '医疗-医药',
            '医疗-器械',
            '医疗-医疗服务',
            'TMT-互联网',
            'TMT-智能制造',
            'TMT-平台软件',
            '消费-零售',
            '消费-快消',
            '工业-传统工业',
            '工业-工业自动化',
            '咨询-人力咨询',
            '筹备期经验（从0到1）',
            '猎头',
          ],
        },
        薪酬: {
          label: '薪酬',
          width: '200px',
          type: 'multSelect',
          options: ['30万以下', '30-50万', '50-80万', '80-100万', '100-150万', '150-200万', '200万以上'],
        },
        公司类型: {
          label: '公司类型',
          width: '200px',
          type: 'multSelect',
          options: [
            '国企/央企',
            '民营企业',
            '合资公司',
            '跨国企业',
            '上市公司',
            '非上市公司',
            '集团/控股公司',
            '海外工作',
            '自主创业',
          ],
        },
        上市经验: {
          label: '上市经验',
          width: '200px',
          type: 'multSelect',
          options: ['主板上市', '创业板上市', '科创板上市', '新三板上市', '香港上市', '美国上市', '无'],
        },
        业务类型: {
          label: '业务类型',
          width: '200px',
          type: 'multSelect',
          options: ['研发业务', '生产业务', '销售和市场业务', '项目业务', '人民币基金', '美元基金'],
        },
        会计准则及证书: {
          label: '会计准则及证书',
          width: '200px',
          type: 'multSelect',
          options: [
            '中国会计准则',
            '国际会计准则（IFRS）',
            '美国会计准则（US GAAP）',
            '注册会计师',
            '管理会计师',
            '董秘资格证',
            '证券从业资格',
            '基金从业资格',
            '无',
          ],
        },
        项目及其他技能: {
          label: '项目及其他技能',
          width: '200px',
          type: 'multSelect',
          options: [
            '财务系统上线',
            'Oracle系统',
            'SAP系统',
            '新公司设立（0-1）',
            '基金设立',
            '战略',
            '收购并购',
            '定价',
            '财务顾问',
            '无',
          ],
        },
        金融业务方向: {
          label: '金融业务方向',
          width: '200px',
          type: 'multSelect',
          options: ['资管', '投行', '专户', '公募', '自营', '财富管理', '并购'],
        },
        技术方向: {
          label: '技术方向',
          width: '200px',
          type: 'multSelect',
          options: ['抗体', '小核酸', '细胞治疗', '基因治疗', '疫苗'],
        },
        治疗领域: {
          label: '治疗领域',
          width: '200px',
          type: 'multSelect',
          options: [
            '肝病',
            'CNS',
            '眼科',
            '罕见病',
            '抗感染',
            '心血管',
            '内分泌/糖尿病',
            '肾病',
            '妇科/生殖',
            '儿科',
            '消化',
            '呼吸',
            '骨科',
          ],
        },
        技术赛道: {
          label: '技术赛道',
          width: '200px',
          type: 'multSelect',
          options: ['小分子', '抗体', 'ADC', '小核酸', 'mRNA', '细胞治疗', '基因治疗', '溶瘤病毒'],
        },
        实体瘤: {
          label: '实体瘤',
          width: '200px',
          type: 'multSelect',
          options: [
            '肺癌',
            '头颈癌',
            '黑色素瘤',
            '泌尿肿瘤',
            '肾癌',
            '妇科肿瘤',
            '乳腺癌',
            '卵巢癌',
            '消化道肿瘤',
            '胃癌',
            '肠癌',
            '肝癌',
            '胰腺癌',
          ],
        },
        医药程序员: {
          label: '医药程序员',
          width: '200px',
          type: 'multSelect',
          options: ['SASS程序员', '数据库程序员', '统计程序员'],
        },
        是否量产: {
          label: '是否量产',
          width: '200px',
          type: 'select',
          options: {
            是: '是',
            否: '否',
            '': '全部',
          },
        },
        是否流片: {
          label: '是否流片',
          width: '200px',
          type: 'select',
          options: {
            是: '是',
            否: '否',
            '': '全部',
          },
        },
        擅长职能: {
          label: '擅长职能',
          width: '200px',
          type: 'multSelect',
          options: [
            '人力',
            '财务',
            '法务',
            '销售',
            '市场',
            '设计',
            '产品',
            '运营',
            '研发',
            '质管',
            '注册',
            '采购',
            '生产',
            '供应链',
            '技术',
          ],
        },
        团队业绩: {
          label: '团队业绩',
          width: '200px',
          type: 'multSelect',
          options: ['0-300万', '300-500万', '500-800万', '800-1000万', '1000-2000万', '2000万+'],
        },
        开票业绩: {
          label: '开票业绩',
          width: '200px',
          type: 'multSelect',
          options: ['0-30万', '30-50万', '50-80万', ' 80-100万', '100-150万', '150-200万', '200-300万', '300万+'],
        },
        擅长职位: {
          label: '擅长职位',
          width: '200px',
          type: 'multSelect',
          options: ['50-100万', '30-50万', '10-30万，10万以下', '100-200万', '200万+'],
        },
        客户资源: {
          label: '客户资源',
          width: '200px',
          type: 'createSelect',
          options: app.kehuziyuanOpt || [],
        },
      },
      addFields: [],
    }
  },
  computed: {
    isAdmin() {
      return app.user['角色'] && app.user['角色'].includes('管理员')
    },
    activeRowId() {
      return this.currentRow._id
    },
  },
  watch: {
    pid: function() {
      this.loadData()
    },
    defaultTab: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.activeTab = this.defaultTab
          this.loadData()
        }
      },
      immediate: true,
    },
    listMode: function() {
      this.loadData()
    },
    ccSearch: function(newVal, oldVal) {
      switch (newVal) {
        case 'nocc':
          this.query['手机'] = '非空'
          break
        case 'cc':
          this.query['手机'] = '空'
          break
        default:
          this.query['手机'] = ''
          break
      }
      this.loadData()
    },
  },
  beforeMount() {
    window.addEventListener('resize', this.resetTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resetTableHeight)
  },
  mounted: async function() {
    if (app.name === 'syn' && this.tableHeads[2].label !== '谷露行业') {
      const gulu1 = {
        label: '谷露行业',
        field: '谷露行业',
        type: 'tag',
        width: 100,
      }
      const gulu2 = {
        label: '谷露职能',
        field: '谷露职能',
        type: 'tag',
        width: 100,
      }
      this.tableHeads.splice(2, 0, gulu1, gulu2)
    }
    await this.loadCate()
    if (localStorage.searchPro_sort) {
      const searchOrder = Object.keys(JSON.parse(localStorage.searchPro_sort))
      this.searchOrder = this.filterSpecialTags(searchOrder)
      for (const field in this.searchFieldsPro) {
        if (!this.searchOrder.includes(field)) {
          this.searchOrder.push(field)
        }
      }
    } else {
      this.searchOrder = Object.keys(this.searchFieldsPro)
    }
    searchOrderCopy = JSON.parse(JSON.stringify(this.searchOrder))
    await this.setHiddenCell()
    await this.setCellOrder()
    Promise.resolve(this.loadData()).then(async () => {
      if (this.defaultTab) {
        this.activeTab = this.defaultTab
      }
      this.$nextTick(() => {
        this.resetTableHeight()
      })
      const pro = await app.service('project').fetch(this.pid)
      try {
        const pids = [pro._id]
        const { data } = await this.$axios.post(`${window.host}/projects/newPipelines`, {
          pids,
        })
        const projectPipeline = data[0]
        Object.assign(pro, projectPipeline)
      } catch (e) {
        console.error(e)
      }
      this.pro = pro
      this.setBelongerOptions()
      this.getBelongerColor()
      // this.loadLvData()
    })
  },
  created() {
    // this.yxColorOn = !(localStorage.yxColorOff === 'true')
  },
  methods: {
    setBelongerOptions() {
      const fields = ['客户开发', '项目对接', '项目经理', '项目成员']
      const arr = []
      fields.forEach(field => {
        arr.push(...(this.pro[field] || []))
      })
      const accounts = [...new Set(arr)].filter(v => v)
      accounts.push('空')
      this.searchFieldsPro['归属人'].options = accounts
    },
    allotBelonger() {
      const tmp = this.$refs.radishTable.getChecked()
      if (tmp.length === 0) return this.$message.error('请先勾选要分配的候选人')
      this.$refs.AllotBelonger.open()
    },
    async allotBelongerConfirm(account) {
      const rows = this.$refs.radishTable.getChecked()
      const filterRows = rows.filter(v => v.归属人 && v.归属人 !== account)
      if (filterRows.length > 0) {
        let str = ''
        const obj = {}
        filterRows.forEach(v => {
          if (!obj[v.归属人]) obj[v.归属人] = []
          obj[v.归属人].push(v.姓名)
        })
        for (const belonger in obj) {
          str += `人选${obj[belonger].join('、')}目前归属${belonger}，`
        }
        str += '请确定是否修改其归属人'
        this.$confirm(str, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '重新选择',
          type: 'warning',
        })
          .then(() => {
            this.modifyBelongerMul(rows, account)
          })
          .catch(() => {
            this.$message.info('已取消修改')
          })
      } else {
        this.modifyBelongerMul(rows, account)
      }
    },
    async modifyBelongerMul(rows, account) {
      const res = await app.service('radish').modifyRadishProject({
        rid: { $in: rows.map(v => v.rid) },
        pid: this.pro._id,
        data: { 归属人: account },
      })
      if (res.status === 'success') {
        this.$message.success('修改成功')
        this.setBelongerColor(rows, account)
        this.$refs.radishTable.cancelChecked()
      } else this.$message.error(res.msg)
    },
    async setBelongerColor(rows = [], account) {
      const obj = this.pro.归属人颜色 || {}
      const hasSetColor = Object.values(obj)
      const lastColor = this.defaultColors.filter(v => !hasSetColor.includes(v))

      if (obj[account]) {
        for (const row of rows) {
          this.$set(row, '归属人', account)
          this.$set(row, 'color', obj[account])
        }
      } else {
        const newColor = lastColor[0]
        if (!newColor) {
          for (const row of rows) {
            this.$set(row, '归属人', account)
            this.$set(row, 'color', '#fff')
          }
        } else {
          obj[account] = newColor
          try {
            await app.service('project').modify({
              id: this.pro._id,
              param: { 归属人颜色: obj },
            })
            this.$set(this.pro, '归属人颜色', obj)
            for (const row of rows) {
              this.$set(row, '归属人', account)
              this.$set(row, 'color', obj[account])
            }
          } catch (e) {
            this.$message.error(e.message)
          }
        }
      }
    },
    getBelongerColor() {
      if (this.pro && this.pro.归属人颜色) {
        const obj = this.pro.归属人颜色
        this.radishes.forEach(radish => {
          if (radish.归属人 && obj[radish.归属人]) {
            this.$set(radish, 'color', obj[radish.归属人])
          }
        })
      }
    },
    loadData: async function() {
      this.radishes = []
      this.loading = true
      const statusTag = this.activeTab == '所有人才' ? null : this.activeTab
      const $sort = { 置顶: -1 }
      $sort['公司排名'] = 1
      $sort['公司'] = -1
      $sort['部门'] = -1
      $sort['职级'] = 1
      $sort.createdAt = -1
      const postData = {
        pid: this.pid,
        statusTag: statusTag,
        $query: this.query,
        $sort: $sort,
        queryExp: this.listMode === 'list',
      }
      const res = await app.service('radish').findByProject(postData)
      if (res.status == 'success') {
        this.total = res.data.group ? res.data.group[this.activeTab] : res.data.total
        const orgData = res.data.data.map(dt => {
          if (!dt['意向']) dt['意向'] = ''
          if (!dt['长期意向']) dt['长期意向'] = ''
          if (dt.初筛通过 && (dt.人选进展阶段 == 'Call' || dt.人选进展阶段 == '推荐'))
            dt.人选进展阶段 = [dt.人选进展阶段, '初筛通过']
          return dt
        })
        this.radishesCopy = JSON.parse(JSON.stringify(orgData))
        this.radishesAll = JSON.parse(JSON.stringify(orgData))
        this.num = res.data.group
        this.$nextTick(function() {
          this.changeSort()
        })
      } else {
        console.log(res)
      }
      this.loading = false
    },
    loadOne: async function(id) {
      if (!(typeof id === 'string')) {
        id = this.currentRow.rid
      }
      let res
      if (this.listMode == 'list') {
        res = await app.service('radish').listMore({ ids: [id] })
      } else {
        res = await app.service('radish').fetch({ _id: id, pid: this.pid })
      }
      if (res.status == 'success') {
        let dt
        if (this.listMode == 'list') {
          dt = res.data.data[0]
        } else {
          dt = res.data[0]
        }
        this.radishes = this.radishes.map(rad => {
          if (rad.rid == id) {
            rad = dt
          }
          return rad
        })
        this.radishesCopy = this.radishesCopy.map(rad => {
          if (rad.rid == id) {
            rad = dt
          }
          return rad
        })
        this.radishesAll = this.radishesAll.map(rad => {
          if (rad.rid == id) {
            rad = dt
          }
          return rad
        })
        this.$nextTick(() => {
          this.$refs.radishTable.setDisplay(true)
        })
      }
    },
    getPhone: async function(id) {
      const res = await app.service('radish').simpleFetch({ _id: id, fields: { 手机: 1 } })
      if (res.status == 'success') {
        const radish = this.radishes.filter(r => r._id === id)
        await app.service('project').saveRecords({
          pid: this.pid,
          项目名称: this.pro && this.pro.项目名称,
          rid: id,
          姓名: radish.姓名,
          type: '查看手机',
        })
        this.radishes.forEach(rad => {
          if (rad.rid == id) {
            rad.手机 = res.data.手机
          }
        })
        this.radishesCopy.forEach(rad => {
          if (rad.rid == id) {
            rad.手机 = res.data.手机
          }
        })
        this.radishesAll.forEach(rad => {
          if (rad.rid == id) {
            rad.手机 = res.data.手机
          }
        })
        this.$nextTick(() => {
          this.$refs.radishTable.setDisplay(true)
        })
      }
    },
    updateOne: async function(id, key, val) {
      this.radishes = this.radishes.map(rad => {
        if (rad.rid == id) {
          rad[key] = val
        }
        return rad
      })
      this.radishesCopy = this.radishesCopy.map(rad => {
        if (rad.rid == id) {
          rad[key] = val
        }
        return rad
      })
      this.radishesAll = this.radishesAll.map(rad => {
        if (rad.rid == id) {
          rad[key] = val
        }
        return rad
      })
      this.$nextTick(() => {
        this.$refs.radishTable.setDisplay(true)
      })
    },
    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      if (catData && catData.length > 0) {
        this.catData = catData
        const tmp = catData.map(item => item['名称'])
        const tmphead = this.tableHeads.map(t => {
          if (t.label == '职能模块') {
            t.options = tmp
          }
          return t
        })
        this.tableHeads = tmphead
        const prem = app.user['SL权限']
        const role = app.user['角色']
        let tmp2 = []
        if (!role || (!role.includes('管理员') && !role.includes('业务助理'))) {
          if (!prem || prem.length == 0) {
            tmp2 = []
          } else {
            const catArr = prem.split(';')
            tmp2 = tmp.filter(c => catArr.includes(c))
          }
        } else {
          tmp2 = JSON.parse(JSON.stringify(tmp))
        }
        tmp2.push('空')
        this.searchFieldsPro['职能模块'].options = tmp2
        this.searchFieldsPro['期望职能'].options = tmp2.slice(0)
      }
      this.searchFieldsPro['行业'].options = JSON.parse(JSON.stringify(app.industries || [])).concat('空')
      this.searchFieldsPro['期望行业'].options = JSON.parse(JSON.stringify(app.industries || [])).concat('空')
      this.refreshFielder()
    },
    changePageData: function() {
      this.radishes = []
      const start = (this.page - 1) * this.limit
      this.radishes = this.radishesAll.slice(start, start + this.limit)
      this.getBelongerColor()
      this.$nextTick(function() {
        this.$refs.radishTable && this.$refs.radishTable.setDisplay(true)
      })
    },
    handleSizeChange: function(val) {
      this.limit = val
      this.changePageData()
    },
    handleCurrentChange: function(val) {
      this.page = val
      this.changePageData()
    },
    handleSearchChange: function(res) {
      const { label, content } = res
      this.searchData[label] = content
      if (label == '职能模块') {
        this.isSearchShow = false
        const currentCat = this.catData.filter(cat => cat['名称'] == content)
        if (currentCat.length > 0) {
          const cat = currentCat[0]
          if (cat['二级职能'] && cat['二级职能'].length > 0) {
            const znArr = cat['二级职能']
            this.searchFieldsPro['细分职能'].options = znArr.concat('空')
          }
          if (cat['擅长方向'] && cat['擅长方向'].length > 0) {
            const scArr = cat['擅长方向']
            this.searchFieldsPro['擅长方向'].options = scArr.concat('空')
          }
        }
        // this.searchFieldsPro['专业职级'].options = content && content.includes('HH-猎头') ? ['R', 'AC', 'C', 'SC', 'PC', 'TL\M', 'SM', 'AD', 'D', 'AP', 'P', 'SP', 'Office Head', 'GM', 'CEO'] : ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
        this.isSearchShow = true
        this.refreshFielder()
      }
    },
    refreshFielder() {
      const isReatedCate = this.searchData.职能模块 && this.searchData.职能模块.some(v => relatedCates.includes(v))
      const searchOrder = searchOrderCopy.slice(0)
      let addFields = []
      if (isReatedCate) {
        addFields = getDisplayLabels((this.searchData && this.searchData.职能模块) || [])
      }
      this.addFields = addFields
      let index = searchOrder.findIndex(v => v === '擅长方向')
      if (index < 0) {
        index = searchOrder.length - 1
      }
      for (const addField of addFields) {
        if (!searchOrder.includes(addField)) {
          searchOrder.splice(index + 1, 0, addField)
        }
      }
      this.$nextTick(v => {
        this.searchOrder = searchOrder
      })
    },
    showSearch: function() {
      this.isSearchShow = !this.isSearchShow
      this.$nextTick(() => {
        this.resetTableHeight()
      })
    },
    changeSort: function() {
      if (this.sortBy === '公司') {
        this.radishesAll = JSON.parse(JSON.stringify(this.radishesCopy))
      } else {
        this.radishesAll.sort((a, b) => {
          if (a[this.sortBy] > b[this.sortBy]) {
            return -1
          } else {
            return 1
          }
        })
      }
      this.page = 1
      this.changePageData()
    },
    handleSearch: async function() {
      const sdt = JSON.parse(JSON.stringify(this.searchData))
      sdt.归属人 = sdt.跟进责任人
      delete sdt.跟进责任人
      // console.log(sdt)
      this.query = sdt
      this.page = 1
      await this.loadData()
      this.$refs.radishTable.reset()
    },
    cleanSearch: function() {
      this.searchData = {
        意向: '',
        长期意向: [],
        姓名: '',
        手机: '',
        英文名: '',
        公司: '',
        部门: '',
        组别: '',
        目前职位: '',
        职能模块: [],
        地域: [],
        细分职能: [],
        平台: [],
        职级: [],
        业绩: [],
        擅长方向: [],
        性别: [],
        曾任职公司: '',
        行业: [],
        附件: '',
      }
      this.addField = []
      // this.searchData = {}
      this.handleSearch()
    },

    clickName: async function(item) {
      this.currentRow = item
      await app.service('project').saveRecords({
        pid: this.pid,
        项目名称: this.pro && this.pro.项目名称,
        rid: item._id,
        姓名: item.姓名,
        type: '查看人选',
      })
      window.open(`${window.frontend}/#/radish-detail-blank/${item.rid}?p=${this.pid}`, '_blank')
    },
    clickCompany: function(companyName) {
      app.root.onPull()
      app.root.$refs.drawer.search({
        type: '公司',
        keywords: companyName,
      })
    },
    clickStatus: function(item) {
      this.currentRow = item
      this.$refs.RadishProgress.open({ rid: item.rid, pid: item.pid })
    },

    setTop: async function() {
      await app
        .service('project')
        .saveRecords({ type: this.currentRow['置顶'] ? '取消置顶' : '置顶', path: '项目人选', page: '项目详情' })
      const row = this.currentRow
      let val = 1
      if (row['置顶'] === 1) {
        val = 0
      }
      const result = await app.service('radish').modifyTop({ rid: row.rid, pid: row.pid, top: val })
      if (result.status == 'success') {
        this.$message.success({ duration: 500, message: '操作成功' })
        this.loadData()
      } else {
        this.$message.error(result.msg)
      }
    },
    showFiles: async function(row) {
      if (row['附件'] && row['附件'] > 0) {
        const res = await app.service('radish').listAttachment({ rid: row.rid })
        if (res.status == 'success') {
          this.popperVisible = true
          this.popperContent = 'files'
          this.files = res.data
          this.popperTarget = `附件${row._id}`
        } else {
          this.$message.error(res.msg)
        }
      } else {
        this.$message.info('没有附件')
      }
    },

    hasPermisson() {
      return hasPermisson(this.pro)
    },
    showAction: async function(row) {
      if (!this.hasPermisson()) return this.$message('没有该项目操作权限')
      const res = await app.service('radish').simpleFetch({ _id: row.rid })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      this.popperVisible = true
      this.popperContent = 'action'
      this.currentRow = row
      this.popperTarget = `操作${row._id}`
    },
    showLvAction: async function(row) {
      if (!this.hasPermisson()) return this.$message('没有该项目操作权限')
      const res = await app.service('radish').simpleFetch({ _id: row.rid })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      this.popperVisible = true
      this.popperContent = 'lvAction'
      this.currentRow = row
      this.popperTarget = `猎微操作${row._id}`
    },

    showIntoProject: function(multi) {
      let rows
      if (multi) {
        const tmp = this.$refs.radishTable.getChecked()
        rows = tmp.map(row => ({ _id: row.rid, 姓名: row['姓名'] }))
      } else {
        const row = this.currentRow
        rows = [{ _id: row.rid, 姓名: row['姓名'] }]
      }
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        app.root.$refs.radishProDialog.show(rows, 'intoProject')
      }
    },
    showRecommend: async function(multi) {
      let rows
      if (multi) {
        await app.service('project').saveRecords({ type: '批量推荐到其他项目', path: '项目人选', page: '项目详情' })
        const tmp = this.$refs.radishTable.getChecked()
        rows = tmp.map(row => ({ _id: row.rid, 姓名: row['姓名'], 手机: row['手机'] }))
      } else {
        await app.service('project').saveRecords({ type: '推荐到其他项目', path: '项目人选', page: '项目详情' })
        const row = this.currentRow
        rows = [{ _id: row.rid, 姓名: row['姓名'], 手机: row['手机'] }]
      }
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      for (const row of rows) {
        if (!row['手机']) {
          this.$alert('请不要勾选cc候选人', { showClose: false })
          return
        }
      }
      app.root.$refs.radishProDialog.show(rows, 'recommend')
    },
    showLvRecommend: async function(multi) {
      let rows
      if (multi) {
        await app.service('project').saveRecords({ type: '批量推荐到其他项目', path: '项目人选', page: '项目详情' })
        const tmp = this.$refs.lvRadishList.getChecked()
        rows = tmp.map(row => ({ _id: row.rid, 姓名: row['姓名'], 手机: row['手机'] }))
      } else {
        await app.service('project').saveRecords({ type: '推荐到其他项目', path: '项目人选', page: '项目详情' })
        const row = this.currentRow
        rows = [{ _id: row.rid, 姓名: row['姓名'], 手机: row['手机'] }]
      }
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      for (const row of rows) {
        if (!row['手机']) {
          this.$alert('请不要勾选cc候选人', { showClose: false })
          return
        }
      }
      app.root.$refs.radishProDialog.show(rows, 'recommend')
    },
    recommend: async function() {
      const row = this.currentRow
      if (!row['手机']) {
        this.$alert('cc候选人不能推荐', { showClose: false })
        return
      }
      const res = await app.service('radish').addRecommend({ rid: row.rid, pid: this.pid })
      if (res.status == 'success') {
        this.loadData()
        this.$message.success('推荐成功')
      } else {
        this.$message.info(res.msg)
      }
    },
    async cancelRecommend() {
      await app.service('project').saveRecords({ type: '取消推荐', path: '项目人选', page: '项目详情' })
      const row = this.currentRow
      this.$confirm(`确定取消${row.姓名}的推荐吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await app.service('radish').deleteRecommend({ rid: row.rid, pid: this.pid })
          if (res.status == 'success') {
            this.loadData()
            this.$message.success('取消成功')
          } else {
            this.$message.info(res.msg)
          }
        })
        .catch(() => {})
    },
    uploadCv: async function() {
      await app.service('project').saveRecords({ type: '上传简历', path: '项目人选', page: '项目详情' })
      this.attachType = '原始简历'
      this.uploadType = '原始简历'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    uploadReport: async function() {
      await app.service('project').saveRecords({ type: '上传推荐报告', path: '项目人选', page: '项目详情' })
      this.attachType = '推荐报告'
      this.uploadType = '推荐报告'
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    uploadSuccess: async function(response, file, fileList) {
      const attach = response.map(res => {
        const dt = {
          fileId: res._id,
          uploader: res.uploader,
          originalname: res.originalname,
          src: res.src,
          md5: res.md5,
        }
        dt.rid = this.currentRow.rid
        dt.type = this.attachType
        if (this.attachType === '推荐报告') {
          dt.isFinal = true
        }
        return dt
      })
      if (attach.length > 0) {
        const aRes = await app.service('radish').addAttachment(attach)
        if (aRes.status == 'success') {
          this.$message.success({ duration: 500, message: '上传成功' })
          await this.loadData()
        } else {
          console.log(aRes)
        }
      } else {
        this.$message.info('未添加附件')
      }
      this.$refs.UploadDialog.visible()
      this.$refs.UploadDialog.clean()
    },
    addToFavorite: function() {
      let rows = this.$refs.radishTable.getChecked()
      rows = rows.map(row => ({ _id: row.rid, 姓名: row['姓名'], 手机: row['手机'] }))
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
      } else {
        app.root.$refs.favDialog.show(rows)
      }
    },
    outProject: async function(multi) {
      let rows
      if (multi) {
        await app.service('project').saveRecords({ type: '批量移出项目', path: '项目人选', page: '项目详情' })
        rows = this.$refs.radishTable.getChecked()
      } else {
        await app.service('project').saveRecords({ type: '移出项目', path: '项目人选', page: '项目详情' })
        const row = this.currentRow
        rows = [row]
      }
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      const success = []
      const err = []
      const fail = []
      for (const r of rows) {
        const res = await app.service('radish').outProject({ _id: r._id })
        if (res.status == 'success') {
          success.push(r['姓名'])
        } else if (res.msg == '已推荐') {
          err.push(r['姓名'])
        } else {
          fail.push(r['姓名'])
        }
      }
      let msg = ''
      if (success.length > 0) {
        msg = `${msg + success.join('、')}移出成功；`
      }
      if (err.length > 0) {
        msg = `${msg + err.join('、')}已经推荐不能移出`
      }
      if (fail.length > 0) {
        msg = `${msg + fail.join('、')}移出失败`
      }
      this.loadData()
      this.$alert(msg)
    },
    outAll: async function() {
      this.$confirm('确定移出全部吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await app.service('radish').outProjectAll({ pid: this.pid })
          if ((res.status = 'success')) {
            this.loadData()
          }
          this.$alert(res.msg)
        })
        .catch(() => {})
    },
    // showInterview: function(row) {
    //   const item = row || this.currentRow
    //   this.$refs.interviewDialog.show({ type: 'add', row: item, pid: this.pid, pro: this.pro })
    // },
    // editInterview: function(row) {
    //   const item = this.currentRow
    //   this.$refs.interviewDialog.show({ type: 'edit', row: item, pid: this.pid, pro: this.pro })
    // },
    cancelInterview: function() {
      const row = this.currentRow
      this.$confirm(`确定取消${row.姓名}的面试吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await app.service('radish').deleteInterview({ rid: row.rid, pid: this.pid })
          if (res.status == 'success') {
            this.loadData()
            this.$message.success('取消成功')
          } else {
            this.$message.info(res.msg)
          }
        })
        .catch(() => {})
    },
    showFeedback: function() {
      const row = this.currentRow
      this.$refs.feedbackDialog.show(row, this.pid)
    },
    showClientFeedback: function() {
      const row = this.currentRow
      this.$refs.clientfeedbackDialog.show(row, this.pid)
    },
    // showOffer: function() {
    //   const row = this.currentRow
    //   this.$refs.offerDialog.show(row, this.pid)
    // },
    // showTowork: function() {
    //   const row = this.currentRow
    //   this.$refs.toworkDialog.show(row, this.pid)
    // },
    genRepo: async function() {
      await app.service('project').saveRecords({ type: '生成推荐报告', path: '项目人选', page: '项目详情' })
      app.root.$refs.reportMaker.init({ radish: this.currentRow.rid || this.currentRow._id, project: this.pid })
    },
    showEliminate: function(row) {
      const item = row || this.currentRow
      this.$refs.eliminateDialog.show(item, this.pid)
    },
    editOneField: async function(params) {
      const { item, head, value } = params
      const res = await app.service('radish').simpleFetch({ _id: item.rid })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      const data = {}
      const label = head.field || head.label
      data[label] = value
      const result = await app.service('radish').modifyById({ _id: item.rid, data: data })
      if (result.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
      } else {
        this.$message.error(result.msg)
      }
    },
    changeYi: async function(row, val) {
      const res = await app.service('radish').simpleFetch({ _id: row.rid })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      const result = await app.service('radish').modifyYixiang({ rid: row.rid, pid: row.pid, yixiang: val })
      if (result.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
        // 2022.02.07 暂时关闭修改意向之后弹窗评分
        // if (this.pro['标签'] && this.pro['标签'].length > 0) {
        //   // console.log(row)
        //   this.$refs.proScore.open({
        //     radishId: row.rid,
        //     projectId: this.pro._id,
        //     projectTags: this.pro['标签'],
        //     projectScore: row.pingfen,
        //     radishName: row['姓名'],
        //   })
        // }
      } else {
        this.$message.error(result.msg)
      }
    },
    changeJing: async function(row, val) {
      const res = await app.service('radish').simpleFetch({ _id: row.rid })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      const result = await app
        .service('radish')
        .modifyRadishProject({ rid: row.rid, pid: row.pid, data: { 竞争: val } })
      if (result.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
      } else {
        this.$message.error(result.msg)
      }
    },
    getSimi: async function(item) {
      const res = await app.service('radish').simpleFetch({ _id: item.rid })
      if (res.status == 'fail') {
        this.$message.error(res.msg)
        return
      } else if (res.msg == 'nothave') {
        this.$message.warning('人选不存在')
        this.loadData()
        return
      }
      item._id = item.rid
      if (item.status && item.status > 0) {
        app.root.$refs.simiDialog.show(item)
      }
    },
    showEditDialog: function() {
      let rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      rows = rows.map(row => {
        row._id = row.rid
        return row
      })
      this.$refs.editDialog.show(this.tableHeads, rows)
    },

    showCateDialog: function(type) {
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      const ids = rows.map(r => r.rid)
      this.$refs.cateDialog.show(type, this.catData, ids)
    },

    handleTabClick: function(tab) {
      this.page = 1
      if (this.activeTab === '反馈汇总') {
        console.log('反馈汇总')
      } else if (this.activeTab === '圆手人选') {
        this.loadLvData()
      } else if (this.activeTab !== '最终人选') {
        this.loadData()
      }
    },
    async loadLvData() {
      this.radishes = []
      const $sort = { 置顶: -1 }
      $sort['公司排名'] = 1
      $sort['公司'] = -1
      $sort['部门'] = -1
      $sort['职级'] = 1
      $sort.createdAt = -1
      const postData = {
        pid: this.pid,
        $sort: $sort,
        queryExp: false,
      }
      const res = await app.service('radish').findByProjectLv(postData)
      if (res.status === 'success') {
        const orgData = res.data.data.map(dt => {
          if (!dt['意向']) dt['意向'] = ''
          if (!dt['长期意向']) dt['长期意向'] = ''
          return dt
        })
        this.lvTable = orgData.filter(v => v.lvObj && v.lvObj.deliver)
        this.computedLvBadge()
      } else {
        console.log(res)
      }
    },
    computedLvBadge() {
      let lvBadge = 0
      this.lvTable.forEach(v => {
        const lvObj = v.lvObj || {}
        lvBadge += lvObj.hunterUnreadNum || 0
      })
      this.lvBadge = lvBadge
    },
    resetTableHeight: function() {
      const el = this.$refs.radishTableWapper
      // console.log(document.documentElement.clientHeight, el.offsetTop)
      el && (this.tableHeight = document.documentElement.clientHeight - el.offsetTop - 310)
    },
    setHiddenCell: function() {
      const heads = localStorage[this.storageName]
      if (heads) {
        const cells = JSON.parse(heads)
        const tmp = this.tableHeads.map(h => {
          if (cells[h.label]) {
            h.hidden = cells[h.label]
          } else {
            h.hidden = false
          }
          return h
        })
        this.tableHeads = tmp
      }
    },
    setCellOrder: function() {
      const headSort = localStorage[`${this.storageName}_sort`]
      if (headSort) {
        const cellSort = JSON.parse(headSort)
        this.tableHeads.sort((a, b) => {
          const labelA = a.label
          const labelB = b.label
          if (!cellSort[labelA] || cellSort[labelA] > cellSort[labelB]) {
            return 1
          } else {
            return -1
          }
          // if (!cellSort[labelB] || cellSort[labelA] > cellSort[labelB]) {
          //   return 1
          // } else {
          //   return -1
          // }
        })
      }
    },
    filterSpecialTags(searchOrder) {
      const notSpecialTags = Object.keys(searchFieldsPro)
      const filteredSearchOrder = searchOrder.filter(v => notSpecialTags.includes(v))
      return filteredSearchOrder
    },
    orderCondition: function() {
      app.root.$refs.orderDialog.show({
        items: this.filterSpecialTags(this.searchOrder),
        storageName: 'searchPro',
        hasReset: true,
        onConfirm: () => {
          if (localStorage.searchPro_sort) {
            this.$nextTick(() => {
              this.searchOrder = this.filterSpecialTags(Object.keys(JSON.parse(localStorage.searchPro_sort)))
              searchOrderCopy = this.searchOrder.slice(0)
              this.$nextTick(() => {
                this.refreshFielder()
              })
            })
          }
        },
        onReset: () => {
          this.$nextTick(() => {
            this.searchOrder = Object.keys(searchFieldsPro)
            searchOrderCopy = this.searchOrder.slice(0)
            this.$nextTick(() => {
              this.refreshFielder()
            })
          })
        },
      })
    },
    async deleteAttachment({ _id }) {
      try {
        const { status, msg } = await app.service('radish').deleteAttachment({ _id })
        if (status === 'success') {
          arrRemove(this.files, file => file._id === _id)
          this.$message({ message: msg, type: 'success' })
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async showRadishPortrait() {
      await app.service('project').saveRecords({ type: '岗位匹配度', path: '项目人选', page: '项目详情' })
      app.root.$refs.RadishPortrait.open({ rid: this.currentRow.rid, project: this.pro })
    },
    async addBelonger() {
      const account = app.user.account
      if (this.currentRow.归属人 && this.currentRow.归属人 !== account) {
        this.$confirm(
          `人选${this.currentRow.姓名}目前归属${this.currentRow.归属人}，请确定是否归属到您的待沟通`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(() => {
            this.modifyBelonger(account)
          })
          .catch(() => {
            this.$message.info('已取消修改')
          })
      } else {
        this.modifyBelonger(account)
      }
    },
    async modifyBelonger(account) {
      const res = await app.service('radish').modifyRadishProject({
        rid: this.currentRow.rid,
        pid: this.currentRow.pid,
        data: { 归属人: account },
      })
      if (res.status === 'success') {
        this.$message.success('修改成功')
        this.setBelongerColor([this.currentRow], account)
      } else this.$message.error(res.msg)
    },
    testMatch: async function() {
      const rows = this.$refs.radishTable.getChecked()
      if (rows.length == 0) {
        this.$alert('请勾选人选', { showClose: false })
        return
      }
      const ids = rows.map(r => r.rid).filter(Boolean)
      this.testMatchIds = ids
      const loading = this.$loading({
        lock: true,
        text: '匹配中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        const match = await app.service('radish').recommendMatch({ rids: ids })
        if (match.status === 'success') {
          app.root.onPull()
          app.root.$refs.drawer.search({ type: '人选', keywords: '', result: match.data })
        } else if (match.data && match.data.pid) {
          this.$message.info('无匹配结果')
        } else {
          this.$message.error(match.msg)
        }
      } catch (e) {
        console.error(e)
      }
      loading.close()
    },
    changeColor: function(state) {
      localStorage.yxColorOff = !state
    },
    async updateHighProbability() {
      await app.service('project').saveRecords({
        type: `${this.currentRow['高概率'] ? '取消' : '设置为'}高概率offer人选`,
        path: '项目人选',
        page: '项目详情',
      })
      const res = await app.service('company').updateHighProbability(this.currentRow)
      if (res.status === 'success') {
        this.$set(this.currentRow, '高概率', !this.currentRow['高概率'])
      } else this.$message.error(res.msg)
    },
    // async doRecommend() {
    //   await app.service('project').saveRecords({ type: '推荐给客户', path: '项目人选', page: '项目详情' })
    //   this.$confirm('是否确认将候选人推荐到该项目?', '确认信息', {
    //     type: 'warning',
    //   })
    //     .then(async () => {
    //       const res = await app.service('radish').addRecommend({ rid: this.currentRow.rid, pid: this.pid })
    //       if (res.status == 'success') {
    //         this.$message.success('推荐成功')
    //         this.loadData()
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //     .catch(() => {})
    // },
    async openQuickChat() {
      await app.service('project').saveRecords({ type: '快速沟通', path: '项目人选', page: '项目详情' })
      this.$refs.QuickChat.open({ radish: this.currentRow, project: this.pro })
    },
    // async openRecommendFeedback() {
    //   await app.service('project').saveRecords({ type: '推荐反馈', path: '项目人选', page: '项目详情' })
    //   this.$refs.RecommendFeedback.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openInterviewCreate() {
    //   await app.service('project').saveRecords({ type: '安排客户面试', path: '项目人选', page: '项目详情' })
    //   this.$refs.InterviewCreate.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openInterviewFeedback() {
    //   await app.service('project').saveRecords({ type: '面试反馈', path: '项目人选', page: '项目详情' })
    //   this.$refs.InterviewFeedback.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openOfferMaybe() {
    //   await app.service('project').saveRecords({ type: '拟offer', path: '项目人选', page: '项目详情' })
    //   this.$refs.OfferMaybe.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openOfferFeedback() {
    //   await app.service('project').saveRecords({ type: 'offer反馈', path: '项目人选', page: '项目详情' })
    //   this.$refs.OfferFeedback.result = '接受'
    //   this.$refs.OfferFeedback.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openOfferFeedbackGiveup() {
    //   await app.service('project').saveRecords({ type: '人选放弃', path: '项目人选', page: '项目详情' })
    //   this.$refs.OfferFeedback.result = '拒绝'
    //   this.$refs.OfferFeedback.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openOfferConfirm() {
    //   await app.service('project').saveRecords({ type: '确认offer', path: '项目人选', page: '项目详情' })
    //   this.$refs.OfferConfirm.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openOfferEdit() {
    //   await app.service('project').saveRecords({ type: '修改offer', path: '项目人选', page: '项目详情' })
    //   this.$refs.OfferEdit.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openLeaveGuide() {
    //   await app.service('project').saveRecords({ type: '离职辅导', path: '项目人选', page: '项目详情' })
    //   this.$refs.LeaveGuide.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openToworkConfirm() {
    //   await app.service('project').saveRecords({ type: '确认到岗', path: '项目人选', page: '项目详情' })
    //   this.$refs.ToworkConfirm.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openToworkNot() {
    //   await app.service('project').saveRecords({ type: '未入职', path: '项目人选', page: '项目详情' })
    //   this.$refs.ToworkNot.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openWarrantyConfirm() {
    //   await app.service('project').saveRecords({ type: '确认过保', path: '项目人选', page: '项目详情' })
    //   this.$refs.WarrantyConfirm.open({ radish: this.currentRow, project: this.pro })
    // },
    // async openWarrantyNot() {
    //   await app.service('project').saveRecords({ type: '未过保', path: '项目人选', page: '项目详情' })
    //   this.$refs.WarrantyNot.open({ radish: this.currentRow, project: this.pro })
    // },
    onExportProjectReport() {
      const radishes = this.getProjectReportData()
      if (radishes.length === 0) {
        this.$message.error('无数据')
        return
      }
      this.$refs.projectExportOptions.show(this.pid)
    },
    onExportProjectMappingReport() {
      const radishes = this.getProjectReportData()
      this.$refs.projectReportDialog.show(this.pro, radishes)
    },
    getProjectReportData() {
      let radishes = this.$refs.radishTable.getChecked()
      if (radishes.length === 0) {
        // radishes = this.$refs.radishTable.getTableData()
        radishes = JSON.parse(JSON.stringify(this.radishesAll))
      }
      return radishes
    },
    showYejifenchengDia() {
      const radish = JSON.parse(JSON.stringify(this.currentRow))
      radish._id = radish.rid
      this.$refs.YejifenchengDia.open({ radish, project: this.pro })
    },
    yejiConfirm() {
      const radish = JSON.parse(JSON.stringify(this.currentRow))
      radish._id = radish.rid
      this.$refs.ProgressDia.open({ radish, project: this.pro, compName: 'offerConfirm' })
    },
    showDia(compName) {
      const radish = JSON.parse(JSON.stringify(this.currentRow))
      radish._id = radish.rid
      this.$refs.ProgressDia.open({ radish, project: this.pro, compName })
    },
    showOffer() {
      this.showDia('OfferEdit')
      this.$nextTick(() => {
        this.$refs.ProgressDia.$refs.compt.type = 'view'
      })
    },
    interviewCreateFinal() {
      const radish = JSON.parse(JSON.stringify(this.currentRow))
      radish._id = radish.rid
      this.$refs.ProgressDia.open({
        radish,
        project: this.pro,
        compName: 'InterviewCreate',
        defaultData: { isFinal: true },
      })
    },
    async offerFeedbackGiveup() {
      const radish = JSON.parse(JSON.stringify(this.currentRow))
      radish._id = radish.rid
      this.$refs.ProgressDia.open({
        radish,
        project: this.pro,
        compName: 'OfferFeedback',
        defaultResult: '拒绝',
      })
    },
    async generateProjectSearchProject() {
      const loading = this.$loading({
        lock: true,
        text: '正在生成推荐人选汇总报告，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      try {
        await app.service('project').saveRecords({
          type: '项目推荐人选汇总',
          path: '项目人选列表批量操作',
          page: '项目详情',
          data: { pid: this.pid },
        })
        const res = await app.service('project').generateProjectSearchReport({ pid: this.pid })
        if (res && res.status === 'success' && res.data) {
          const manager = this.pro.项目经理
            ? Array.isArray(this.pro.项目经理)
              ? this.pro.项目经理.join(';')
              : this.pro.项目经理
            : ''
          const duijie = this.pro.项目对接
            ? Array.isArray(this.pro.项目对接)
              ? this.pro.项目对接.join(';')
              : this.pro.项目对接
            : ''
          this.$refs.ProjectReportEditor.open({
            url: res.data.url,
            md5: res.data.md5,
            manager,
            duijie,
            projectId: this.pro._id,
            documentType: res.data && res.data.documentType,
            fileType: res.data && res.data.fileType,
            originalname: res.data && res.data.originalname,
          })
        } else if (res && res.status === 'fail') {
          this.$message.error(res.msg)
        }
      } catch (e) {
        console.error(e)
        this.$message.error(`生成项目搜索进度报告出错`)
      }
      loading.close()
    },
    confirm() {},
    onCopy: function(e) {
      const content = window
        .getSelection()
        .toString()
        .split('\n')
      e.clipboardData.setData('text/plain', content[0])
      e.preventDefault()
    },
  },
}
</script>
<style>
.radish-list .el-tabs .el-tabs__item {
  height: 30px;
  line-height: 30px;
  font-size: 13px;
}
.dropdown-popper .item {
  position: relative;
  display: block;
  width: 100%;
  padding: 10px 20px;
  color: #606266;
  background: #fff;
  cursor: pointer;
  line-height: 1;
  white-space: nowrap;
}
.dropdown-popper .item:hover {
  color: #fff;
  background: #409eff;
}
.lv-badge {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
}
</style>
